module.exports = __webpack_public_path__ + "img/641-0bf353.png";